import React, { useEffect, useRef, useState } from 'react';
import './cohort-view-user-list.styles.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';

const CohortViewUserList = ({
    cohort,
    userList,
    mcList,
    progressNumbers
}) => {

    const [ compiledUsers, setCompiledUsers ] = useState(null);
    const timeoutRef = useRef();
    const navigate = useNavigate();

    useEffect(() => {
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
    }, [])

    useEffect(() => {
        if (!userList || !mcList || !progressNumbers) return;
        compileUserData();
    }, [userList, mcList, progressNumbers])

    useEffect(() => {
        if (!compiledUsers) return;
        timeoutRef.current = setTimeout(() => {
            for (let user of Object.values(compiledUsers)) {
                document.getElementById(`progress-${user.cst_key}`).style.width = user.pct + "%";
            }
        }, 500);
    }, [compiledUsers])
    
    function compileUserData() {
        let compiledData = {};
        let totalMcs = Object.values(mcList).length;
        for (let user of Object.values(userList)) {
            let completeCount = 0;
            for (let mc of Object.values(mcList)) {
                let mcProg = progressNumbers[mc.mc_key];
                if (!mcProg) continue;
                let userProg = mcProg[user.cst_key];
                if (!userProg) continue;
                let progNum = userProg.progNum;
                if (progNum >= 9) completeCount++;
            }
            compiledData[user.cst_key] = {
                'fName': user.fName,
                'lName': user.lName,
                'cst_key': user.cst_key,
                'complete': completeCount,
                'total': totalMcs,
                'pct': ((completeCount/totalMcs) * 100).toFixed(0).toLocaleString(),
            }
        }
        setCompiledUsers(compiledData);
    }

    return (
        <div className='cohort-view-user-list'>
            {
                (compiledUsers) &&
                Object.values(compiledUsers)
                .sort((a, b) => 
                    a.lName.toLowerCase() > b.lName.toLowerCase() 
                    ? 1 
                    : (
                        a.lName.toLowerCase() === b.lName.toLowerCase()
                        ? (
                            a.fName.toLowerCase() > b.fName.toLowerCase() 
                            ? 1 
                            : -1
                        )
                        : -1 
                    )
                )
                .map(u => {

                    return (
                        <div key={u.cst_key} className='cohort-view-user-item'>
                            <div className='user-name'>
                                {u.fName} {u.lName}
                            </div>
                            <div className='progress-container'>
                                <div className="progress">
                                    <div 
                                        className="progress-bar"
                                        id={`progress-${u.cst_key}`} 
                                        aria-valuenow={u.pct} 
                                        min="0" 
                                        max="100" >
                                    </div>
                                </div>
                                <div className='meta'>{u.complete}/{u.total} Complete</div>
                                
                            </div>
                            <div className='buttons'>
                                <button 
                                    className='g-button small-btn'
                                    onClick={() => navigate(`user/${u.cst_key}`)}>
                                    <FontAwesomeIcon icon={faMagnifyingGlass} />
                                </button>
                            </div>
                        </div>
                    )
                })
            }
        </div>
    )
}

export default CohortViewUserList